import { useSearchParams } from "react-router-dom"

import { useTranslation } from "@be-miniapp/i18n"
import { ActionBar } from "@be-miniapp/ui/components/ui/action-bar"

import { usePartnerInfo } from "@/store/partner-information"
import { Layout } from "@/components/layout"

const UnauthorizedPage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const isSesssionExpired = searchParams.get("session_expired")
  const errorCode = searchParams.get("error_code")
  const getPartnerData = usePartnerInfo((state) => state.getPartnerData)

  const partnerData = getPartnerData()
  return (
    <Layout>
      <div className="flex size-full flex-col bg-white">
        <ActionBar className="shadow-xs" border>
          {t("common.non_supported.title")}
        </ActionBar>

        <div className="flex w-full flex-1">
          <div className="flex w-full flex-col items-center justify-center gap-3">
            <img src="/images/19.webp" className="w-64 object-cover" />
            <span className="p-8 text-center font-medium text-sm">
              {isSesssionExpired
                ? t("unauthorized_title_partner", {
                    partnerName: partnerData.name,
                  })
                : t("unauthorized_title")}
            </span>
            {errorCode ? (
              <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600">
                Ma loi: {errorCode}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </Layout>
  )
}

UnauthorizedPage.displayName = "UnauthorizedPage"
export { UnauthorizedPage }
